module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"object":"objekt","person":"person","lifeskillSymbol":"Symboliserer livsområdet","connect":"Kobles til person og handling","action":"handling"},"en":{"object":"object","person":"person","lifeskillSymbol":"Symbolizes lifeskill","connect":"Connects to person and action","action":"action"}}')
  delete Component.options._Ctor
}
